import { jsx as _jsx } from 'react/jsx-runtime'
import { forwardRef } from 'react'
const SvgIconBookmarkHeartActive = (props, ref) =>
  _jsx('svg', {
    viewBox: '0 0 24 24',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    ref: ref,
    ...props,
    children: _jsx('path', {
      fillRule: 'evenodd',
      d: 'M2 8.395C2 4.905 4.546 2 7.95 2c1.51 0 2.946.605 4.05 1.592C13.104 2.605 14.54 2 16.05 2 19.454 2 22 4.904 22 8.395c0 2.155-.898 4.047-2.31 5.928-1.386 1.848-3.408 3.846-5.682 6.093l-1.304 1.294a1 1 0 0 1-1.406.002l-1.307-1.287c-2.264-2.242-4.3-4.258-5.682-6.101C2.898 12.44 2 10.55 2 8.395Z',
      clipRule: 'evenodd',
    }),
  })
const ForwardRef = forwardRef(SvgIconBookmarkHeartActive)
export default ForwardRef
